import getFullComposeViewState from './getFullComposeViewState';
import { FULL_COMPOSE_VIEW_TYPE_POPOUT } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export default function isInPopOutWindow(): boolean {
    const viewState = getFullComposeViewState();

    if (viewState && viewState.viewType == FULL_COMPOSE_VIEW_TYPE_POPOUT) {
        return true;
    }

    return false;
}
